import { connect } from "react-redux";

import Converter from "../Components/Converters/Converter";
import {
  updateConverterType,
  updateConverterId,
  getConverterConfig,
  getMDLData,
  updateConverterMultipleMdl,
  getConversionStatus,
  addConversion,
  processConversion,
  preProcessConversion,
  updateStoreConversionStatus,
  updateStoreConversionStatusDescription,
  updateConversionStatus,
  startAskingConversionStatus,
  setConverterConfigOpen,
  setConverterOnEdition,
  copyConverter,
  removeConverter,
} from "../store/actions/actions";
const mapStateToProps = (state) => {
  return {
    user: state.authentication.email,
    locale: state.locale,
    converters: state.converters,
    conversions: state.conversions,
    enableCRUD: state.enableCRUD,
    onlyOneFileAtTime: state.onlyOneFileAtTime,
    isConverterConfigOpen: state.isConverterConfigOpen,
    converterOnEdition: state.converterOnEdition,
  };
};

const mapDispatchToProps = {
  updateConverterType,
  updateConverterId,
  getConverterConfig,
  addConversion,
  processConversion,
  preProcessConversion,
  getConversionStatus,
  updateStoreConversionStatus,
  updateStoreConversionStatusDescription,
  updateConversionStatus,
  getMDLData,
  updateConverterMultipleMdl,
  startAskingConversionStatus,
  setConverterConfigOpen,
  setConverterOnEdition,
  copyConverter,
  removeConverter,
};

export default connect(mapStateToProps, mapDispatchToProps)(Converter);
